import { render } from "./OneOffPlanBand.vue?vue&type=template&id=a89916cc&scoped=true"
import script from "./OneOffPlanBand.vue?vue&type=script&lang=js"
export * from "./OneOffPlanBand.vue?vue&type=script&lang=js"

import "./OneOffPlanBand.vue?vue&type=style&index=0&id=a89916cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89916cc"]])

export default __exports__